/**************************************************
 * Nombre:       Dialogo_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Pedido from "../Formularios/Formulario_Pedido";

const Dialogo_Pedido = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')


        let dox = await guardarDoc('pedidos', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

    }

    const borrar = async () => {
        await borrarDoc('pedidos', datos.id)
        terminar({aviso: 'Pedido borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Pedido props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {/*datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            */}


        </Grid>
    )

}
export default Dialogo_Pedido